import { api } from "@/api";
import { CorrectionPreviewDto } from "./correctionPreview";

// Same gates as the reopen; nothing is persisted.
export const previewManualReopenMatch = async (
  matchId: string
): Promise<CorrectionPreviewDto> => {
  const res = await api.client.post(
    `/matches/${matchId}/manual-reopen/preview`
  );
  return res.data;
};
